import React from 'react';

const BRAND_COLORS = {
  Surron: '#00E5A0', Talaria: '#FF6B35', Kugoo: '#00B4D8',
  Zero: '#FFD60A', Segway: '#E63946', Other: '#8B5CF6'
};
const COND_COLORS = {
  'Brand New': 'var(--volt)', 'Like New': 'var(--info)',
  'Good': 'var(--warning)', 'Fair': 'var(--orange)'
};

export function BikeImage({ brand, photos, size = 'full' }) {
  const c = BRAND_COLORS[brand] || BRAND_COLORS.Other;
  const h = size === 'card' ? 192 : 256;

  // If has real photos, show them
  if (photos && photos.length > 0) {
    return (
      <div style={{ height: h, width: '100%', overflow: 'hidden' }}>
        <img src={photos[0]} alt={brand} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div>
    );
  }

  return (
    <div style={{ height: h, width: '100%', borderRadius: size === 'card' ? '12px 12px 0 0' : 0, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden', background: `linear-gradient(135deg, ${c}15, ${c}30)` }}>
      <div style={{ position: 'absolute', inset: 0, opacity: 0.1, backgroundImage: `radial-gradient(circle at 30% 50%, ${c} 0%, transparent 50%), radial-gradient(circle at 70% 50%, ${c} 0%, transparent 50%)` }} />
      <div style={{ textAlign: 'center', zIndex: 1 }}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}>
          <circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M15 6l-4 8h6l-3 3"/><path d="M5.5 17.5L9 9h3"/><path d="M15 6h3l2 4"/>
        </svg>
        <span style={{ fontSize: 12, fontWeight: 500, color: c }}>{brand}</span>
      </div>
    </div>
  );
}

export default function ListingCard({ listing, onClick }) {
  return (
    <div className="card" style={{ cursor: 'pointer' }} onClick={() => onClick(listing)}>
      <BikeImage brand={listing.brand} photos={listing.photos} size="card" />
      <div style={{ padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 8 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600, lineHeight: 1.3 }}>{listing.name}</h3>
          <span className="badge" style={{ background: `${COND_COLORS[listing.condition] || 'var(--text-3)'}20`, color: COND_COLORS[listing.condition] || 'var(--text-3)', flexShrink: 0 }}>{listing.condition}</span>
        </div>
        <p style={{ fontSize: 22, fontWeight: 700, color: 'var(--volt)', marginBottom: 12, fontFamily: "'Space Grotesk'" }}>AED {listing.price?.toLocaleString()}</p>
        <div style={{ display: 'flex', gap: 16, color: 'var(--text-2)', fontSize: 12, marginBottom: 12 }}>
          <span>⚡ {listing.mileage}</span>
          <span>🔋 {listing.battery}</span>
        </div>
        <div style={{ color: 'var(--text-3)', fontSize: 12 }}>📍 {listing.location}</div>
      </div>
    </div>
  );
}
